import React, { Component } from 'react';
import { Provider } from 'react-redux';
import App from './App';

import Volkno from '../pages/Volkno';
import MobileReddit from '../pages/MobileReddit';
import Portfolio from '../pages/Portfolio';
import CreativeBoost from '../pages/CreativeBoost';
import TrafficClock from '../pages/TrafficClock';
import HighlyRelevant from '../pages/HighlyRelevant';
import IMDB from '../pages/IMDB';


import Layout from './Layout';
import DevTools from './DevTools';
const { Router, Route, IndexRoute, hashHistory } = require('react-router')
/**
 * Component is exported for conditional usage in Root.js
 */
module.exports = class Root extends Component {
  render() {
    const { store } = this.props;
    return (
      /**
       * Provider is a component provided to us by the 'react-redux' bindings that
       * wraps our app - thus making the Redux store/state available to our 'connect()'
       * calls in component hierarchy below.
       */
      <Provider store={store}>
        <Router history={hashHistory}>
          <Route path='/' component={Layout}>
            <IndexRoute component={App} /> 
            <Route path='/pages/Volkno' component={Volkno}  />   
            <Route path='/pages/MobileReddit' component={MobileReddit}  />  
            <Route path='/pages/Portfolio' component={Portfolio}  />  
            <Route path='/pages/CreativeBoost' component={CreativeBoost}  />  
            <Route path='/pages/Traffic-Clock' component={TrafficClock}  />  
            <Route path='/pages/HighlyRelevant' component={HighlyRelevant}  />  
            <Route path='/pages/IMDB' component={IMDB}  />  
     
          </Route>
        </Router>
      </Provider>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/containers/Root.prod.js
 **/